var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ele-main"},[_c('eleHead'),_c('div',{staticClass:"ele-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }